import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    background: theme.palette.background.paper,
    height: '100%',
    borderRadius: 8,
    border: `1px solid ${theme.palette.divider}`,
  },
}))
